/// <reference types="vite/client" />

interface ImportMetaEnv {
  /** Baked in at image build time; unset in local dev builds. */
  readonly VITE_APP_VERSION?: string;
}

/**
 * Version label shown in the sidebar. Local builds have nothing baked in, so
 * they fall back to a marker that is obviously not a released version.
 */
export const APP_VERSION: string =
  (import.meta.env as ImportMetaEnv).VITE_APP_VERSION?.trim() || 'dev';
